"use client";

import { cn } from "@jesus-central-church/shared";
import { Clock, MapPin, Users } from "lucide-react";

export interface EventsInfoStripProperties {
  className?: string;
}

export function EventsInfoStrip({ className }: EventsInfoStripProperties) {
  return (
    <div className={cn("border-t border-freedom/10 bg-boldness", className)}>
      <div className="container mx-auto px-6 py-12 md:px-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div className="text-center">
            <MapPin className="text-strategy-gold mx-auto mb-3 h-8 w-8" />
            <h3 className="mb-2 font-bold text-lg text-freedom">Locatie</h3>
            <p className="text-sm text-freedom/60">
              Jesus Central Church
              <br />
              Rijsselseweg 1
              <br />
              2803 PZ Gouda
            </p>
          </div>
          <div className="text-center">
            <Clock className="text-strategy-gold mx-auto mb-3 h-8 w-8" />
            <h3 className="mb-2 font-bold text-lg text-freedom">
              Zondagdienst
            </h3>
            <p className="text-sm text-freedom/60">
              Elke zondag om 10:00
              <br />
              Deuren open vanaf 09:30
              <br />
              Kinderprogramma beschikbaar
            </p>
          </div>
          <div className="text-center">
            <Users className="text-strategy-gold mx-auto mb-3 h-8 w-8" />
            <h3 className="mb-2 font-bold text-lg text-freedom">
              Eerste keer?
            </h3>
            <p className="text-sm text-freedom/60">
              Je bent van harte welkom!
              <br />
              Meld je aan bij de welkomstteam
              <br />
              voor een rondleiding.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
